// Contact.jsx

import React from 'react'
import { Link } 
    from 'react-router-dom'

const Contact = () => {
    return (
        <div>
            This is contact page
        </div>
    )
}

export default Contact
